// Helpers locales simples
const getSafeInt = (val) => {
    if (!val) return 0;
    const cleanVal = String(val).replace(/\D/g, ''); 
    return parseInt(cleanVal || '0', 10);
};

// Busca el valor de una columna ignorando mayúsculas, minúsculas y espacios vacíos.
const getValue = (row, possibleNames) => {
    const names = Array.isArray(possibleNames) ? possibleNames : [possibleNames];
    const rowKeys = Object.keys(row);
    
    for (const name of names) {
        const normalizedToFind = name.toLowerCase().trim();
        const foundKey = rowKeys.find(k => k.toLowerCase().trim() === normalizedToFind);
        if (foundKey !== undefined) return row[foundKey];
    }
    return undefined;
};

export const SancorStrategy = {
    name: "SANCOR",

    /**
     * cleanSearchValue: Estandariza el nPoliza como String y quita el .0 de Excel.
     */
    cleanSearchValue: (rawVal) => {
        if (rawVal === 0 || rawVal === "0") return "0";
        if (rawVal === undefined || rawVal === null || rawVal === "") return '';
        
        let s = String(rawVal).trim();
        if (s.endsWith('.0')) s = s.replace('.0', '');
        return s;
    },

    /**
     * findExistingRecord: BUSQUEDA PROFESIONAL EN MEMORIA.
     * Para Sancor, el match de unicidad en la cobranza se hace estrictamente por 'nroRecibo'.
     */
    findExistingRecord: (row, existingRecords) => {
        if (!existingRecords || existingRecords.length === 0) return null;

        const nReciboRaw = getValue(row, ['Recibo', 'nRecibo', 'Comprobante', 'Nro Recibo']);
        const nReciboExcel = nReciboRaw ? Number(String(nReciboRaw).replace(/\D/g, '')) : 0;

        // Buscamos en el listado de la DB que nos pasó el orquestador
        return existingRecords.find(rec => 
            getSafeInt(rec.nroRecibo) === nReciboExcel
        ) || null;
    },

    processRow: (row, existingRecord) => {
        // 1. Extracción y Limpieza de Importe (SIEMPRE SE TOMA EL DEL EXCEL)
        let importeExcel = 0;
        const rawImporte = getValue(row, ['Importe', 'Monto', 'Total', 'Valor']);

        if (rawImporte !== undefined && rawImporte !== null && rawImporte !== '') {
            if (typeof rawImporte === 'number') {
                importeExcel = rawImporte;
            } else {
                const stringValue = String(rawImporte);
                const cleanValue = stringValue
                    .replace(/\$/g, '')
                    .replace(/\s/g, '')
                    .replace(/\./g, '')
                    .replace(',', '.');
                
                importeExcel = parseFloat(cleanValue);
                if (isNaN(importeExcel)) importeExcel = 0;
            }
        }
        
        const moneda = getValue(row, ['Moneda', 'Divisa']) || '$';
        const formaPagoExcel = getValue(row, ['FormaPago', 'Forma de Pago', 'Medio']) || 'Tarjeta de Credito';
        const motivoExcel = getValue(row, ['Motivo', 'Desc. Motivo']) || '';
        const nReciboRaw = getValue(row, ['Recibo', 'Comprobante', 'nRecibo']);
        const nRecibo = nReciboRaw ? Number(String(nReciboRaw).replace(/\D/g, '')) : 0;

        // 2. Definición del Intento de Cobro (Idempotencia)
        const excelIntento = getSafeInt(getValue(row, ['IntentoCobro', 'Intento']));
        const intentoFinal = excelIntento > 0 
            ? excelIntento 
            : (existingRecord ? (getSafeInt(existingRecord.intentoCobro) + 1) : 1);

        // 3. Variables de estado a determinar
        let estadoGestion = '';
        let estadoDeuda = '';
        let motivoDeuda = motivoExcel;

        if (existingRecord && getSafeInt(existingRecord.intentoCobro) === intentoFinal) {
            estadoGestion = existingRecord.estado || 'Pendiente';
            estadoDeuda = existingRecord.estadoDeuda || 'Rechazo';
            if (!motivoDeuda) motivoDeuda = existingRecord.motivoDeuda;
        } else {
            // Lógica para NUEVO INTENTO según medio de pago
            if (formaPagoExcel.toUpperCase().includes('CBU')) {
                // --- LÓGICA CBU SANCOR ---
                if (intentoFinal === 1) {
                    estadoGestion = 'Sin Asignar';
                    estadoDeuda = 'Intento de Cobro';
                } else if (intentoFinal >= 2 && intentoFinal <= 4) {
                    estadoGestion = 'Pendiente';
                    estadoDeuda = 'Intento de Cobro';
                } else {
                    estadoGestion = 'Pendiente';
                    estadoDeuda = 'Rechazo';
                }
            } else {
                // --- LÓGICA TARJETA DE CREDITO / OTROS ---
                estadoGestion = intentoFinal === 1 ? 'Sin Asignar' : 'Pendiente';
                estadoDeuda = 'Rechazo';
            }
        }

        return {
            action: 'SAVE',
            data: {
                nroRecibo: nRecibo, 
                intentoCobro: intentoFinal,
                motivoDeuda: motivoDeuda,
                importe: importeExcel,
                moneda: moneda,
                estadoDeuda: estadoDeuda,
                estado: estadoGestion,
                formaPago: formaPagoExcel,
                ultimaImportacion: new Date().toISOString(),
            }
        };
    }
};